import React, { lazy } from 'react';
import { TwitterIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-darkest border-t border-white/10 pt-16 pb-8" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-187">
          <div className="col-span-1 md:col-span-2" data-id="element-188">
            <div className="flex items-center mb-6" data-id="element-189">
              <img src="https://cdn.magicpatterns.com/uploads/rX3SBp63zs47X13CcgwCHd/IMG_2082.png" alt="Qtap" className="h-16 w-auto brightness-0 invert" loading="lazy" data-id="element-190" />
            </div>
            <p className="text-gray-400 max-w-sm mb-4" data-id="element-191">
              The world's first NFC-enabled smart t-shirt. Merging premium
              sportswear with dynamic digital identity.
            </p>
            <p className="text-gray-500 text-sm" data-id="element-192">
              Developed by{' '}
              <a href="https://stdiglobal.com/" target="_blank" rel="noopener noreferrer" className="text-brand-cyan hover:text-brand-sky transition-colors font-medium" data-id="element-193">
                STDI Global
              </a>
            </p>
          </div>

          <div data-id="element-194">
            <h4 className="font-bold text-white mb-6" data-id="element-195">Links</h4>
            <ul className="space-y-4" data-id="element-196">
              <li data-id="element-197">
                <a href="#how-it-works" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-198">
                  How It Works
                </a>
              </li>
              <li data-id="element-199">
                <a href="#features" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-200">
                  Features
                </a>
              </li>
              <li data-id="element-201">
                <a href="#pricing" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-202">
                  Pricing & Pre-order
                </a>
              </li>
              <li data-id="element-203">
                <a href="#faq" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-204">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-205">
            <h4 className="font-bold text-white mb-6" data-id="element-206">Legal</h4>
            <ul className="space-y-4" data-id="element-207">
              <li data-id="element-208">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-209">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-210">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-211">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-212">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-213">
                  Contact Us
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-8" data-id="element-214">
              <a href="#" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-215">
                <TwitterIcon className="w-5 h-5" data-id="element-216" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-217">
                <InstagramIcon className="w-5 h-5" data-id="element-218" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-219">
                <LinkedinIcon className="w-5 h-5" data-id="element-220" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500" data-id="element-221">
          <p data-id="element-222">
            © {new Date().getFullYear()} Qtap Smart Apparel. All rights
            reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-223">
            Developed by{' '}
            <a href="https://stdiglobal.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-224">
              STDI Global
            </a>
          </p>
        </div>
      </div>
    </footer>;
}